"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegendItem = void 0;
var styled_components_1 = require("styled-components");
var types_1 = require("../../utils/types");
var theme_1 = require("../../utils/theme");
var bulletStyles = {
    height: theme_1.scaffolding.md,
    width: theme_1.scaffolding.md
};
exports.StyledLegendItem = styled_components_1.default.span(__assign(__assign({}, theme_1.font), { alignItems: 'center', color: theme_1.colors.grey5, display: 'inline-flex', fontSize: '11px', lineHeight: '11px' }), function (_a) {
    var alignment = _a.alignment, bulletColor = _a.bulletColor;
    return ({
        ':after': __assign(__assign({}, bulletStyles), { backgroundColor: bulletColor, content: alignment === types_1.RIGHT ? "''" : "", marginLeft: theme_1.scaffolding.sm }),
        ':before': __assign(__assign({}, bulletStyles), { backgroundColor: bulletColor, content: alignment === types_1.LEFT ? "''" : "", marginRight: theme_1.scaffolding.sm }),
        marginBottom: theme_1.scaffolding.sm,
        marginLeft: alignment === types_1.RIGHT ? theme_1.scaffolding.md : '0px',
        marginRight: alignment === types_1.LEFT ? theme_1.scaffolding.md : '0px',
        marginTop: theme_1.scaffolding.sm
    });
});
//# sourceMappingURL=styles.js.map